import { useState } from 'react'

import type { SeatInfo } from '@/components/billing/billing-seat.interface'

export interface UseSeatsStateReturn {
  seatInfo: SeatInfo | null
  setSeatInfo: React.Dispatch<React.SetStateAction<SeatInfo | null>>
  isLoading: boolean
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
  isAddingSeats: boolean
  setIsAddingSeats: React.Dispatch<React.SetStateAction<boolean>>
  isRemovingSeats: boolean
  setIsRemovingSeats: React.Dispatch<React.SetStateAction<boolean>>
  error: string | null
  setError: React.Dispatch<React.SetStateAction<string | null>>
}

export const useSeatsState = (): UseSeatsStateReturn => {
  const [seatInfo, setSeatInfo] = useState<SeatInfo | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [isAddingSeats, setIsAddingSeats] = useState(false)
  const [isRemovingSeats, setIsRemovingSeats] = useState(false)
  const [error, setError] = useState<string | null>(null)

  return {
    seatInfo,
    setSeatInfo,
    isLoading,
    setIsLoading,
    isAddingSeats,
    setIsAddingSeats,
    isRemovingSeats,
    setIsRemovingSeats,
    error,
    setError,
  }
}
